import React from 'react';

const MobileMessageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="#06AED4"
      data-slot="icon"
      className="h-8 w-8"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z"
      />
    </svg>
  );
};

export default MobileMessageIcon;

export const NewMobileMessageIcon = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8444 19.2288C14.7822 18.8282 14.75 18.4179 14.75 18C14.75 13.5817 18.3552 10 22.8026 10C27.2499 10 30.8552 13.5817 30.8552 18C30.8552 18.9981 30.6713 19.9535 30.3352 20.8345C30.2654 21.0175 30.2304 21.109 30.2146 21.1804C30.1989 21.2512 30.1928 21.301 30.1911 21.3735C30.1894 21.4466 30.1993 21.5272 30.2192 21.6883L30.6217 24.9585C30.6653 25.3125 30.6871 25.4895 30.6282 25.6182C30.5766 25.731 30.485 25.8205 30.3711 25.8695C30.2411 25.9254 30.0646 25.8995 29.7117 25.8478L26.5265 25.3809C26.3601 25.3565 26.277 25.3443 26.2012 25.3448C26.1263 25.3452 26.0745 25.3507 26.0011 25.3661C25.927 25.3817 25.8323 25.4172 25.643 25.4881C24.7597 25.819 23.8024 26 22.8026 26C22.3844 26 21.9737 25.9683 21.5727 25.9073M16.3816 30C19.3465 30 21.75 27.5376 21.75 24.5C21.75 21.4624 19.3465 19 16.3816 19C13.4167 19 11.0132 21.4624 11.0132 24.5C11.0132 25.1106 11.1103 25.6979 11.2895 26.2467C11.3653 26.4787 11.4032 26.5947 11.4157 26.6739C11.4286 26.7567 11.4309 26.8031 11.4261 26.8867C11.4214 26.9668 11.4014 27.0573 11.3613 27.2383L10.75 30L13.7448 29.591C13.9083 29.5687 13.99 29.5575 14.0614 29.558C14.1365 29.5585 14.1764 29.5626 14.2501 29.5773C14.3201 29.5912 14.4242 29.6279 14.6323 29.7014C15.1806 29.8949 15.7691 30 16.3816 30Z"
        stroke="#22CCEE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NewSelectedMobileMessageIcon = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.75" width="40" height="40" rx="20" fill="#91bee7" />
      <path
        d="M14.8444 19.2288C14.7822 18.8282 14.75 18.4179 14.75 18C14.75 13.5817 18.3552 10 22.8026 10C27.2499 10 30.8552 13.5817 30.8552 18C30.8552 18.9981 30.6713 19.9535 30.3352 20.8345C30.2654 21.0175 30.2304 21.109 30.2146 21.1804C30.1989 21.2512 30.1928 21.301 30.1911 21.3735C30.1894 21.4466 30.1993 21.5272 30.2192 21.6883L30.6217 24.9585C30.6653 25.3125 30.6871 25.4895 30.6282 25.6182C30.5766 25.731 30.485 25.8205 30.3711 25.8695C30.2411 25.9254 30.0646 25.8995 29.7117 25.8478L26.5265 25.3809C26.3601 25.3565 26.277 25.3443 26.2012 25.3448C26.1263 25.3452 26.0745 25.3507 26.0011 25.3661C25.927 25.3817 25.8323 25.4172 25.643 25.4881C24.7597 25.819 23.8024 26 22.8026 26C22.3844 26 21.9737 25.9683 21.5727 25.9073M16.3816 30C19.3465 30 21.75 27.5376 21.75 24.5C21.75 21.4624 19.3465 19 16.3816 19C13.4167 19 11.0132 21.4624 11.0132 24.5C11.0132 25.1106 11.1103 25.6979 11.2895 26.2467C11.3653 26.4787 11.4032 26.5947 11.4157 26.6739C11.4286 26.7567 11.4309 26.8031 11.4261 26.8867C11.4214 26.9668 11.4014 27.0573 11.3613 27.2383L10.75 30L13.7448 29.591C13.9083 29.5687 13.99 29.5575 14.0614 29.558C14.1365 29.5585 14.1764 29.5626 14.2501 29.5773C14.3201 29.5912 14.4242 29.6279 14.6323 29.7014C15.1806 29.8949 15.7691 30 16.3816 30Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
